import { createSlice } from '@reduxjs/toolkit';

// Simple slice to store QR data from the API
const qrSlice = createSlice({
  name: 'qr',
  initialState: {
    qrInfo: null,
    loading: false,
    regenerating: false,
    error: null,
  },
  reducers: {
    setQRInfo: (state, action) => {
      state.qrInfo = action.payload;
      state.loading = false;
      state.error = null;
    },
    setQRLoading: (state, action) => {
      state.loading = action.payload;
    },
    setQRRegenerating: (state, action) => {
      state.regenerating = action.payload;
    },
    setQRError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.regenerating = false;
    },
    clearQRError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setQRInfo,
  setQRLoading,
  setQRRegenerating,
  setQRError,
  clearQRError,
} = qrSlice.actions;
export default qrSlice.reducer;
